import React from "react";

const SvgMessagesBubbleSquareAlternate = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M21.5 1.5h-19a2 2 0 00-2 2v13a2 2 0 002 2h4v3a1 1 0 001.707.707l3.709-3.707H21.5a2 2 0 002-2v-13a2 2 0 00-2-2zm0 14.748a.25.25 0 01-.25.25H11.5a1 1 0 00-.707.293L8.5 19.084V17.5a1 1 0 00-1-1H2.75a.25.25 0 01-.25-.25V3.75a.25.25 0 01.25-.25h18.5a.25.25 0 01.25.25z" />
  </svg>
);

export default SvgMessagesBubbleSquareAlternate;
